import { RestakingAccountState, RestakingBalancesState, RestakingVaultState } from "@/utils/dataTypes"
import { atom } from "jotai"

export const restakingVaultState = atom<RestakingVaultState>(null)

export const restakingBalancesAtom = atom<RestakingBalancesState>({
  stakeToken: 0,
  rewardToken: 0,
})

export const restakingAccountAtom = atom<RestakingAccountState | null>(null)
